// @flow

import styled from 'styled-components';

export const HighlightBox = styled.div`
  background-color: #fafafa;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-sizing: border-box;
`;
